export function unique<T>(value: T, index: number, arr: Array<T>): boolean {
    return arr.indexOf(value) === index;
}
